/* global IntersectionObserver */
import { useEffect, useRef } from 'react';

// eslint-disable-next-line import/prefer-default-export
export function useScrollReveal<T extends HTMLElement = HTMLDivElement>(
  options: { threshold?: number; rootMargin?: string; once?: boolean } = {}
) {
  const ref = useRef<T>(null);
  const { threshold = 0.15, rootMargin = '0px 0px -60px 0px', once = true } = options;

  useEffect(() => {
    const container = ref.current;
    if (!container) return undefined;

    const items = container.querySelectorAll('.scroll-reveal');
    if (items.length === 0) return undefined;

    items.forEach((item, index) => {
      const el = item as HTMLElement;
      if (!el.style.getPropertyValue('--reveal-index')) {
        el.style.setProperty('--reveal-index', String(index));
      }
    });

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            if (once) observer.unobserve(entry.target);
          } else if (!once) {
            entry.target.classList.remove('revealed');
          }
        });
      },
      { threshold, rootMargin }
    );

    items.forEach(item => observer.observe(item));

    return () => observer.disconnect();
  }, [threshold, rootMargin, once]);

  return ref;
}
